/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-31 15:08:51
 *
 *******************************************************/
import React, { useEffect, useState } from 'react';
import { Button, Popover, ActionList, Icon } from '@shopify/polaris';
import { DuplicateMinor, DropdownMinor } from '@shopify/polaris-icons';
// DONE
const PopoverCloneButton = props => {
  const { countCustomFilterTree, customFilterTreeLimit, openWarningModal, disabled, filterId, handleClone } =
    props;

  const [active, setActive] = useState(false);
  const [limitOption, setLimitOption] = useState(5);

  useEffect(() => {
    if (customFilterTreeLimit === -1) {
      setLimitOption(5);
      return;
    }
    if (countCustomFilterTree >= customFilterTreeLimit) {
      setLimitOption(0);
      return;
    }
    const duplicateLimit = customFilterTreeLimit - countCustomFilterTree;
    setLimitOption(duplicateLimit);
  }, [countCustomFilterTree, customFilterTreeLimit]);

  const handleCloneFilterTree = cloneTimes => {
    // Close popover button
    setActive(!active);

    // Call action
    handleClone(filterId, cloneTimes);
  };

  const handleActive = () => {
    if (countCustomFilterTree >= customFilterTreeLimit && customFilterTreeLimit !== -1) {
      openWarningModal(true);
      return;
    }
    setActive(true);
  };

  const activator = (
    <Button disabled={disabled} size="slim" onClick={() => handleActive()}>
      <span className="clone">
        <Icon source={DuplicateMinor} />
        <Icon source={DropdownMinor} />
      </span>
    </Button>
  );

  const items = [
    { content: '1', onAction: () => handleCloneFilterTree(1) },
    { content: '2', onAction: () => handleCloneFilterTree(2) },
    { content: '3', onAction: () => handleCloneFilterTree(3) },
    { content: '4', onAction: () => handleCloneFilterTree(4) },
    { content: '5', onAction: () => handleCloneFilterTree(5) }
  ];

  const allowItems = items.slice(0, limitOption);

  return (
    <div className="cloneFilter">
      <Popover active={active} activator={activator} onClose={() => setActive(false)}>
        <Popover.Pane>
          <ActionList items={allowItems} />
        </Popover.Pane>
      </Popover>
    </div>
  );
};

export default PopoverCloneButton;
